module.exports = __webpack_public_path__ + "static/media/login-password-icon.3cea2aa3.svg";